import { render, staticRenderFns } from "./failure.vue?vue&type=template&id=64da2cc0&scoped=true"
import script from "./failure.vue?vue&type=script&lang=js"
export * from "./failure.vue?vue&type=script&lang=js"
import style0 from "./failure.vue?vue&type=style&index=0&id=64da2cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da2cc0",
  null
  
)

export default component.exports